import { Injectable } from '@angular/core';

import { mergeMap } from 'rxjs/operators';

import { User, UsersService } from '@era/security-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { safeMap } from '../effects.helpers';
import * as memberUserActions from '../member-user/member-user.actions';
import { UserApiActions, UserListItemUIActions, UserListUIActions, UserResolverActions } from './user.actions';

@Injectable()
export class UserEffects {
  constructor(
    private readonly userService: UsersService,
    private readonly actions$: Actions
  ) {}

  userLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserResolverActions.usersRequested),
      mergeMap(() =>
        safeMap(
          this.userService.getUsers(),
          (users: User[]) => UserApiActions.usersLoaded({ users }),
          (error) => UserApiActions.usersLoadedError({ error })
        )
      )
    );
  });

  userAddedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserListUIActions.userAddRequested),
      mergeMap(({ user }) =>
        safeMap(
          this.userService.addUser(user),
          (user: User) => UserApiActions.userAdded({ user }),
          (error) => UserApiActions.userAddedError({ error })
        )
      )
    );
  });

  userDeletedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserListItemUIActions.userDeleteRequested),
      mergeMap(({ user }) =>
        safeMap(
          this.userService.removeUser(user.id),
          () => [UserApiActions.userDeleted({ user }), memberUserActions.UserApiActions.userDeleted({ user })],
          (error) => UserApiActions.userDeletedError({ error })
        )
      )
    );
  });
}
